module.exports = __webpack_public_path__ + "assets/img/ourservice02.0fb08e5a.png";